import React from 'react'
import { useRecoilState } from 'recoil'

import { Wrapper, AppBarR as PersistentDrawerRight } from '../components/common'
import { OfficeDetail } from '../components/office'
import BookingPageGuidance from '../components/onboarding/BookingPageGuidance'
import { usePageVisitTracker } from '../hooks/usePageVisitTracker'
import { sessionState } from '../state'

const Book = () => {
  const [userState, setUserState] = useRecoilState(sessionState)
  const {
    hasVisited,
    markVisited,
    isLoading: isLoadingPageVisit
  } = usePageVisitTracker('booking')
  const [showGuidance, setShowGuidance] = React.useState(false)

  // Show guidance if user hasn't visited booking page before
  React.useEffect(() => {
    if (!isLoadingPageVisit && !hasVisited && userState.user) {
      setShowGuidance(true)
    }
  }, [isLoadingPageVisit, hasVisited, userState.user])

  // Handle guidance dismissal
  const handleGuidanceDismiss = () => {
    setShowGuidance(false)
    markVisited()
  }

  // Reset booking form to 1 day when Book page loads
  React.useEffect(() => {
    if (userState.selectedRecurAmount !== 1) {
      setUserState(prev => ({
        ...prev,
        selectedRecurAmount: 1
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Empty dependency array means this runs once on mount

  console.log('render')
  return (
    <>
      <PersistentDrawerRight></PersistentDrawerRight>
      <Wrapper>
        {showGuidance && (
          <BookingPageGuidance
            visible={showGuidance}
            onDismiss={handleGuidanceDismiss}
          />
        )}
        {userState.user && <OfficeDetail />}
      </Wrapper>
    </>
  )
}

export default Book
